import { gql } from '@apollo/client';

export const FETCH_EXISTING_PLANS = gql`
  query Flex_FetchExistingPlans($userId: Int!) {
    user(id: $userId) {
      id
      accounts {
        id
        customPlans {
          id
          active
        }
      }
    }
  }
`;
